import React, { useState, useEffect } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Button, DataTable, Modal } from '@arnsbogroup/react-voicearchive'
import { MemoryStatusChip } from 'components/datatable'

export default NiceModal.create(({ order, linkType, linkUid, targetLanguageId = null }) => {
  const modal = useModal()
  const [memories, setMemories] = useState([])
  const [selectedIds, setSelectedIds] = useState([])
  const [loading, setLoading] = useState(true)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    let url = `/rest/v2/memory?search[customerId]=${order.customer.uid}&pageSize=200`
    if (targetLanguageId) {
      url += `&search[languageUid]=${targetLanguageId}`
    }
    fetch(url)
      .then(r => r.json())
      .then(({ data }) => setMemories(data || []))
      .finally(() => setLoading(false))
  }, [])

  const handleSubmit = async () => {
    if (!selectedIds.length) return
    setSubmitting(true)
    try {
      const { success, errors } = await fetch('/rest/v2/memory/attach', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ memoryIds: selectedIds, link: { linkType, linkUid } }),
      }).then(r => r.json())
      if (!success) {
        toastr.error((errors || []).join(', '))
        return
      }
      toastr.success(`${selectedIds.length} ${selectedIds.length === 1 ? 'memory' : 'memories'} attached.`)
      modal.resolve()
      modal.remove()
    } catch (e) {
      toastr.error(e.message)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      show={modal.visible}
      title="Attach memories"
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      dialogPanelClasses="max-w-2xl"
    >
      <div className="space-y-4">
        {targetLanguageId && (
          <p className="text-xs text-gray-500">Showing memories for this customer filtered by version language.</p>
        )}
        <DataTable
          loading={loading}
          head={{
            text: { label: 'Memory' },
            language_name: { label: 'Language' },
            status: { label: 'Status' },
          }}
          body={{
            text: (m) => <span className="text-sm">{m.text}</span>,
            language_name: (m) => m.language_name || '-',
            status: (m) => <MemoryStatusChip memory={m} />,
          }}
          entries={memories}
          rowSelectionKey="uid"
          rowsSelected={selectedIds}
          onRowSelected={(uid) =>
            setSelectedIds(prev =>
              prev.includes(uid) ? prev.filter(id => id !== uid) : [...prev, uid]
            )
          }
          noDataMessage={loading ? 'Loading...' : 'No customer memories found.'}
        />
        <div className="flex gap-2">
          <Button
            onClick={handleSubmit}
            disabled={!selectedIds.length || submitting}
          >
            {submitting ? 'Attaching...' : `Attach ${selectedIds.length || ''} ${selectedIds.length === 1 ? 'memory' : 'memories'}`}
          </Button>
          <Button variant="outline" onClick={() => modal.remove()}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  )
})
